import React from 'react';
import MuiSwitch from '@shared/components/MuiSwitch';

/**
 * @typedef {object} HeaderProps
 * @property {boolean} showUnreadOnly
 * @property {() => void} toggleShowUnreadOnly
 */

/**
 * @param {HeaderProps} props
 */
const Header = props => {
  const { showUnreadOnly, toggleShowUnreadOnly } = props;

  return (
    <div className='notification-header'>
      <h3>Notifications</h3>
      <div className='show-unread-toggle'>
        <p>Only show unread</p>
        <MuiSwitch checked={showUnreadOnly} onChange={toggleShowUnreadOnly} />
      </div>
    </div>
  );
};

export default Header;
